import { Avatar, Badge, Dropdown, Menu, Tooltip } from "antd";
import { Header } from "antd/lib/layout/layout";
import {
  MenuFoldOutlined,
  BellOutlined,
  MenuUnfoldOutlined,
  SearchOutlined,
  LogoutOutlined,
  UserOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import Notifications from "../Notifications";
import Search from "antd/lib/input/Search";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../features/AuthSlice";
import { userDetails } from "../../features/UserSlice";
import GetNotifcationsApi from "../../api/notifications/GetNotificationsApi";
import { positionDetails } from "../../features/PositionSlice";
import BackButton from "./BackButton";

function MainHeader(props) {
  const [notifications, setNotifications] = useState(false);
  const userState = useSelector((state) => state.userState.value);
  const setupAccountState = useSelector(
    (state) => state.setupAccountState.value
  );
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [notificationCount, setNotificationCount] = useState(0);
  const positionState = useSelector((state) => state.positionState.value);

  useEffect(() => {
    if (positionState?.id) {
      getNotifications();
    }
  }, [positionState]);

  async function getNotifications() {
    const apiResponse = await GetNotifcationsApi(
      1,
      10,
      "UnRead",
      positionState?.id
    );
    if (apiResponse.success) {
      setNotificationCount(apiResponse.data?.totalUnRead);
    }
  }

  function toUserProfile() {
    if (setupAccountState) {
      navigate("/settings/user-profile");
    } else {
      navigate("/setup-account/user-profile");
    }
  }

  function toSettings() {
    navigate("/settings");
  }

  function logoutNow() {
    // 🔑 NEW: Clear all filters on logout
    sessionStorage.removeItem('topPlansFilters');
    
    localStorage.setItem("authToken", "");
    localStorage.setItem("authUser", "");
    dispatch(logout());
    dispatch(userDetails({}));
    navigate("/login");
  }

  function changePosition(position) {
    // 🔑 NEW: Clear filters when changing position
    sessionStorage.removeItem('topPlansFilters');
    
    dispatch(positionDetails(position));
    localStorage.setItem("stPosition", position.id);
    navigate("/");
  }

  function renderPositions() {
    let output = [];
    userState?.positions?.forEach((position) => {
      output.push(
        <div
          onClick={() => changePosition(position)}
          key={position.id}
          className={
            "py-2 pl-5 cursor-pointer " +
            (positionState.id === position.id
              ? "bg-gray-200"
              : "hover:bg-gray-100")
          }
        >
          <div>{position.designation?.name}</div>
          <div className="text-xs text-gray-500">{position.unit?.name}</div>
        </div>
      );
    });
    return output;
  }

  const menu = (
    <Menu style={{ width: "280px" }}>
      <div className="p-2 text-center">
        {userState?.imageUrl ? (
          <Avatar
            size={64}
            className="cursor-pointer"
            src={userState?.imageUrl}
          />
        ) : (
          <Avatar size={64}>
            {userState?.firstName?.charAt(0).toUpperCase()}
          </Avatar>
        )}
        <div className="text-base mt-1">{userState?.firstName}</div>
      </div>
      <Menu.Divider />
      <div>
        <div className="ml-3">Positions</div>
        <div>{renderPositions()}</div>
      </div>

      <Menu.Divider />
      <Menu.Item key="0">
        <div className="flex items-center" onClick={() => toUserProfile()}>
          <UserOutlined className="w-4 mr-1" /> Your profile
        </div>
      </Menu.Item>
      {setupAccountState && (
        <Menu.Item key="1">
          <div className="flex items-center" onClick={() => toSettings()}>
            <SettingOutlined className="w-4 mr-1" /> Settings
          </div>
        </Menu.Item>
      )}
      <Menu.Item key="1">
        <div className="flex items-center">
          <QuestionCircleOutlined className="w-4 mr-1" /> Help and Support
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3">
        <div className="flex items-center" onClick={() => logoutNow()}>
          <LogoutOutlined className="w-4 mr-1" /> Logout
        </div>
      </Menu.Item>
    </Menu>
  );

  const search = (
    <Menu style={{ padding: "8px" }}>
      <Search placeholder="input search text" style={{ width: "100%" }} />
    </Menu>
  );

  return (
    <>
      <Header
        className="site-layout-background flex items-center border-b"
        style={{
          backgroundColor: "#fff",
          paddingLeft: "24px",
          paddingRight: "24px",
        }}
      >
        <div className="flex-1 flex justify-between items-center">
          <div className="flex items-center">
            <div className="flex h-full text-lg mr-3">
              {props.menu ? (
                <MenuUnfoldOutlined
                  className="th-pri-hover"
                  onClick={() => props.openMenu()}
                />
              ) : (
                <MenuFoldOutlined
                  className="th-pri-hover"
                  onClick={() => props.openMenu()}
                />
              )}
            </div>
            <BackButton />
          </div>
          <div className="flex items-center">
            <div className="flex h-full md:hidden mr-3 sm:mr-5">
              <Dropdown
                placement="bottomRight"
                overlay={search}
                trigger={["click"]}
              >
                <SearchOutlined className="text-lg th-pri-hover" />
              </Dropdown>
            </div>
            <Tooltip title={"Approvals"}>
              <FileDoneOutlined
                onClick={() => navigate("/settings/target-approvals")}
                className="mr-3 sm:mr-5 text-lg th-pri-hover"
              />
            </Tooltip>
            <Tooltip title={"Notification"}>
              <Badge
                count={notificationCount && notificationCount}
                offset={[-18, 0]}
                overflowCount={9}
              >
                <BellOutlined
                  onClick={() => setNotifications(true)}
                  className="mr-3 sm:mr-5 text-lg th-pri-hover"
                />
              </Badge>
            </Tooltip>
            {setupAccountState && (
              <Tooltip title={"Settings"}>
                <SettingOutlined
                  onClick={() => toSettings()}
                  className="mr-3 sm:mr-5 text-lg th-pri-hover"
                />
              </Tooltip>
            )}
            <Dropdown
              placement="bottomRight"
              overlay={menu}
              trigger={["click"]}
              className={"cursor-pointer"}
            >
              {userState?.imageUrl ? (
                <Avatar
                  size={"large"}
                  className="cursor-pointer"
                  src={userState?.imageUrl}
                />
              ) : (
                <Avatar size={"large"}>
                  {userState?.firstName?.charAt(0).toUpperCase()}
                </Avatar>
              )}
            </Dropdown>
          </div>
        </div>
      </Header>
      <Notifications
        visible={notifications}
        onClose={() => setNotifications(false)}
        handleNotificationCount={() => getNotifications()}
      />
    </>
  );
}

export default MainHeader;
